module.exports = __webpack_public_path__ + "static/media/paper.8285596a.png";